import angular from 'angular';
import kformUtils from '~/components/kform/utils/kform-utils';
import template from './radio.html';

const radioConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('radio', {
		title:      'Radio',
		template,
		/**
		 * @param {any} data
		 * @param {any} options
		 * @returns {any}
		 */
		tableView(data, options) {
			// eslint-disable-next-line unicorn/no-array-for-each
			Object.keys(options.component.values).forEach(index => {
				if (
					Object.prototype.hasOwnProperty.call(options.component.values, index)
					&& options.component.values[index].value === data
				) {
					return options.component.values[index].label;
				}
				return null;
			});
			return data;
		},
		children:   false,
		selectable: true,
		settings:   {
			autofocus:    false,
			disabled:     false,
			input:        true,
			tableView:    true,
			inputType:    'radio',
			label:        'Radio',
			key:          'radio',
			hideLabel:    false,
			values:       [],
			defaultValue: '',
			protected:    false,
			fieldSet:     false,
			persistent:   true,
			hidden:       false,
			clearOnHide:  true,
			validate:     {
				card: '0-1',
				custom:        '',
			},
			event:        {
				onChange: null,
			},
			kdata:        {
				submit: true,
			},
		},
		icon:          'fa fa-dot-circle-o',
		views:         [
			{
				name:     'Display',
				template: 'kform/components/radio/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/common/data.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/radio/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		controller: /* @ngInject */ (/** @type {any} */ $scope) => {
			if ($scope.options && $scope.options.building) {
				return;
			}
			$scope.changeValue = () => {
				if (typeof $scope.component.event.onChange === 'string') {
					const custom = ''.concat($scope.component.event.onChange, '; ');
					kformUtils.evaluate(custom, {
						data: $scope.data,
						form: $scope.form,
					});
				}
			};
		},
	});
};

export default angular.module('app').config(radioConfig);
